import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { Link } from "react-router-dom";
import logo from "../assets/images/krishnasilver.png";
import aboutImg from "../assets/images/mix-item-2-blue.png";

const Footer = () => {

    const [showTopBtn, setShowTopBtn] = useState(false);
    const [contactInfo, setContactInfo] = useState({});

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {

        axios
            .get("https://kskrishnasilver.com/api/contact.php")
            .then((res) => {
                setContactInfo(res.data);
            })
            .catch((err) => console.log(err));

    }, []);

    const handleClick = () => {
        if (!contactInfo.mobile) return;

        const message = "Hii ...";

        // remove spaces
        const phoneNumber = contactInfo.mobile.replace(/\s+/g, "");

        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        const url = isMobile
            ? `whatsapp://send?phone=91${phoneNumber}&text=${encodeURIComponent(message)}`
            : `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(url, "_blank");
    };

    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="footer-top">

                        <div className="footer-col">
                            <img src={logo} alt="Krishna Silver" className="footer-logo" />

                            <p>
                                Superior quality of silver ornaments with Exquisite & Elegant designs has made us one of the leading manufacturer. We offer our customers top-notch designs in every category with customized solution as well with an expertise in manufacturing and designing silver ornaments as per the customer’s requirement.
                            </p>

                            <div className="footer-social">

                                <Link to="https://www.facebook.com/profile.php?id=100025439691121" target="_blank">
                                    <i className="fa-brands fa-facebook-f"></i>
                                </Link>


                                <Link to="https://www.instagram.com/krishna_silver_rajkot/" target="_blank">
                                    <i className="fa-brands fa-instagram"></i>
                                </Link>

                            </div>
                        </div>


                        {/* QUICK LINKS */}
                        <div className="footer-col">
                            <h3>Quick Links</h3>

                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/collections">Our Collections</Link></li>
                                <li><Link to="/contact-us">Contact Us</Link></li>
                            </ul>
                        </div>


                        {/* CONTACT */}
                        <div className="footer-col">

                            <h3>Get In Touch</h3>

                            <div className="contact-item">
                                <i className="fa-solid fa-phone"></i>
                                <span><Link to={`tel:+91${contactInfo.mobile}`}> +91 {contactInfo.mobile} </Link></span>
                            </div>

                            <div className="contact-item">
                                <i className="fa-solid fa-envelope"></i>
                                <span><Link to={`mailto:${contactInfo.email}`}> {contactInfo.email} </Link></span>
                            </div>

                            <div className="contact-item">
                                <i className="fa-solid fa-location-dot"></i>
                                <span>
                                    <Link to={contactInfo.map_link} target="_blank"> {contactInfo.address} </Link>
                                </span>
                            </div>

                            <div className="contact-item">
                                <i className="fa-solid fa-clock"></i>
                                <span>{contactInfo.working_hours}</span>
                            </div>

                        </div>

                    </div>


                    {/* Divider */}
                    <div className="footer-divider"></div>


                    {/* COPYRIGHT */}
                    <div className="footer-bottom">
                        © <span id="year">{new Date().getFullYear()}</span> Krishna Silver. All Rights Reserved.
                    </div>
                </div>
            </footer>

            {/* WhatsApp Button */}
            <Link className="whatsapp-btn" onClick={handleClick}>
                <i className="fab fa-whatsapp"></i>
                <span className="wa-ripple"></span>
            </Link>

            {/* Back To Top Button */}
            {showTopBtn && (
                <button className="backtotop-btn" onClick={scrollToTop}>
                    <i className="fa-solid fa-arrow-up"></i>
                </button>
            )}
        </>
    );
};

export default Footer;